<div>
	<div #croppieParent></div>
	<div class="input-container right">
		<button class="button sm cancel" translate="cancel" (click)="onCancel()"></button>
		<button class="button sm save" translate="save" (click)="onSave()"></button>
	</div>
</div>
